<template>
  <v-app-bar app clipped-left color="white" height="68">
    <v-avatar size="32" class="ml-2" >
        <v-img :src="require('../../src/assets/images-v2/icon_logikoss_color.png')"></v-img>
    </v-avatar>
    <v-btn
      icon
      @click="$emit('toggleDrawer')"
      v-if="$vuetify.breakpoint.mobile"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-spacer class="hidden-md-and-up"></v-spacer>
    <v-spacer class="hidden-sm-and-down"></v-spacer>

    <div dense class="mt-1">
      <v-menu  offset-y :offset="[0, 10]" :close-on-content-click="true" content-class="language-menu-dropdown">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-web</v-icon>
          </v-btn>
        </template>

        <v-list dense :min-width="80" class="py-0">
          <v-list-item
            v-for="(lang, index) in languages"
            :key="`lang-${lang.lang}-${index}`"
            @click="changeLang(lang.lang, lang.flag)"
            class="px-0 d-flex justify-center"
          >
            <v-list-item-title
              class="text-center"
              style="font-size: 0.8rem; width: 100%"
            >
              {{ lang.label }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div fluid class="mt-lg-0 mt-3">
      <NotificationHeaderButton/>
    </div>
    <div>
      <div v-if="!$vuetify.breakpoint.mobile" id="greetingsView">

        <p style="margin-bottom:0px;font-weight:700;padding:0px">{{ userLogged.name }}</p>
        <ol style="padding:0px; font-size:12px;">{{ userLogged.email }}</ol>
      </div>
    </div>

    <v-menu offset-y>
      <template v-slot:activator="{ on }">

        <v-list class="px-2">
          <v-list-item v-on="on">
            <div style="display: block">
              <v-avatar>
                <img style="width: 35px;height: 35px;background-color: #f1f5f7;" :src="profileImage">
              </v-avatar>
              <v-icon v-if="!$vuetify.breakpoint.mobile" small>fa-chevron-down</v-icon>
            </div>
          </v-list-item>
        </v-list>

      </template>
      <v-list dense class="mt-1">
        <ProfileModal mode="update"></ProfileModal>

        <v-list-item
          @click="logout"
        >
          <v-list-item-title style="color: #000000!important;display: inline-flex; margin: auto;" class="text-center pt-1">
            <h5 style="font-size: 0.9rem;font-weight: normal;margin: auto;margin-left: 20px;color: black">{{ $t('fields.header.logout') }}</h5>
            <v-icon class="mr-3" color="black" size="30px">icon-Salir</v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import NotificationHeaderButton from '@/components/Notifications/NotificationHeaderButton'
import ProfileModal from '../modals/ProfileModal'

export default {
  name: 'Header',
  components: { NotificationHeaderButton, ProfileModal },
  data () {
    return {
      isFull: false,
      elem: '',
      flag_lang: 'spain.jpg',
      img: {
        tests: '../../src/assets/images-v2/flags/spain.jpg'
      },
      languages: [
        { label: 'ES', lang: 'es', flag: 'spain.jpg' },
        { label: 'EN', lang: 'en', flag: 'us.jpg' },
        { label: 'PT', lang: 'pt', flag: 'br.jpg' }
      ]
    }
  },
  props: {
    show: {}
  },
  created () {
    this.$gates.setPermissions(this.$store.getters.userPermissions)
  },
  mounted () {
  },
  methods: {
    fullScreen () {
      this.isFull = true
      this.elem = document.documentElement
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen()
      } else if (this.elem.webkitRequestFullscreen) { /* Safari */
        this.elem.webkitRequestFullscreen()
      } else if (this.elem.msRequestFullscreen) { /* IE11 */
        this.elem.msRequestFullscreen()
      }
    },
    closeFullScreen () {
      this.isFull = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen()
      }
    },
    changeLang (lang, flag) {
      localStorage.setItem('locale', lang)
      window.location.reload()
      this.flag_lang = flag
    },
    logout () {
      this.$store.dispatch('logout')
        .then(() => {
          this.logoutRedirect()
        })
    },
    toHome () {
      this.$router.push({ name: 'Dashboard' })
    },
    logoutRedirect () {
      try {
        // eslint-disable-line no-use-before-define
        // nativeFunctions.logout()
        this.logout()
      } catch (e) {
        console.log(e)
      }
      this.$router.push({ name: 'Login' })
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    userLogged () {
      return this.$store.getters.userLogged
    },
    logicoins () {
      return 0
    },
    language () {
      const language = localStorage.getItem('locale') || 'en'
      return language.toUpperCase()
    },
    profileImage () {
      if (this.userLogged.profile_picture) {
        return this.userLogged.profile_picture
      }
      return require('../assets/profile-placeholder.svg')
    }
  }
}
</script>

<style scoped lang="scss">
/*@import '../sass/variables.scss';*/
/*@import '~vuetify/src/styles/styles.sass';*/
$menu-content-border-radius: 50px !important;
.flag {
  width: 35px !important;
  margin-right: -9px;
  padding-right: 1px;
}

.v-app-bar {
  height: 68px !important;
}

.v-list-item {
  padding: 0px;
}

.v-menu__content {
  border-radius: 0.25rem;
  margin-top: 5px;
  width: 161.750px;
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  box-shadow: none;
  box-shadow: 0 5px 12px rgb(0 0 0 / 10%);
}

#greetingsView {
  padding-bottom: 15px;
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #505d69 !important;
  text-align: right;
}

.v-toolbar__content {
  padding-left: 24px;

}

.v-app-bar--fixed{
  -webkit-box-shadow: 0 2px 15px rgb(0 0 0 / 8%) !important;
  box-shadow: 0 2px 15px rgb(0 0 0 / 8%)!important;
}

.selected {
  font-weight: bold;
}

.language-menu-dropdown {
  margin-top: 10px !important;
  box-shadow: 0 3px 5px -1px rgba(0,0,0,0.2) !important;
}

</style>
